module.exports = __webpack_public_path__ + "img/qq_icon.9d25b58b.png";